import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LabelWrapper, Tag, Value } from './styled';
const _SelectedLabel = ({ selected, label, formatOptionLabel }) => {
    const selectedLabel = React.useMemo(() => (formatOptionLabel && selected[0] ? formatOptionLabel(selected[0]) : selected[0]?.label), [formatOptionLabel, selected]);
    return (_jsxs(LabelWrapper, { children: [label && _jsxs("span", { children: [label, ":"] }), _jsx(Value, { "data-testid": 'dropdown-value', children: selectedLabel }), selected.length - 1 > 0 && _jsx(Tag, { "data-testid": 'tag-length', children: `+${selected.length - 1}` })] }));
};
export const SelectedLabel = React.memo(_SelectedLabel);
